import { createContext, useState } from 'react';
const PAGE_SIZE = 6;

const initialFilterValues = {
  passTemplate: '',
};

export const initialPassDownloadTemplates = {
  items: [],
  total: 0,
  pageIndex: 0,
  pageSize: PAGE_SIZE,
  hasMore: false,
  status: 'pending',
  loading: false,
  error: null,
};

const PassDownloadTemplatesListContext = createContext({
  passDownloadTemplates: initialPassDownloadTemplates,
  filterValues: initialFilterValues,
  defaultTemplateUuid: null,
  updatePassDownloadTemplates: () => {},
  updateFilterValues: () => {},
  incrementPageIndex: () => {},
  resetPageIndex: () => {},
});

export const PassDownloadTemplatesListContextProvider = ({ children }) => {
  const [passDownloadTemplates, setPassDownloadTemplates] = useState(
    initialPassDownloadTemplates
  );
  const [filterValues, setFilterValues] = useState(initialFilterValues);
  const [clearPageIndex, setClearPageIndex] = useState(0);

  const updatePassDownloadTemplatesHandler = (param) => {
    setPassDownloadTemplates(param);
  };

  function updateFilterValuesHandler(filterValues) {
    setFilterValues(filterValues);
    setClearPageIndex(clearPageIndex + 1);
  }

  function incrementPageIndexHandler() {
    const index = passDownloadTemplates.pageIndex;
    setPassDownloadTemplates({
      ...passDownloadTemplates,
      pageIndex: index + 1,
    });
  }

  const resetPageIndexHandler = () => {
    setPassDownloadTemplates({
      ...passDownloadTemplates,
      pageIndex: 0,
    });
  };

  const context = {
    passDownloadTemplates,
    filterValues,
    updatePassDownloadTemplates: updatePassDownloadTemplatesHandler,
    updateFilterValues: updateFilterValuesHandler,
    incrementPageIndex: incrementPageIndexHandler,
    resetPageIndex: resetPageIndexHandler,
  };

  return (
    <PassDownloadTemplatesListContext.Provider value={context}>
      {children}
    </PassDownloadTemplatesListContext.Provider>
  );
};

export default PassDownloadTemplatesListContext;
